<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <add-new-insurance title="กรุณากรอกข้อมูล"></add-new-insurance>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AddNewInsurance from "./AddNewInsurance";

export default {
  name: "customerInsuranceAddNew",
  components: {
    AddNewInsurance,
  },
};
</script>
<style scoped></style>
